import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import PersonIcon from "@mui/icons-material/Person";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";
import CRUDPageHeader from "../../components/CRUDPageHeader/index.js";
import PaperComponent from "../../components/PaperComponent";
import { handleErrorResponse } from "../../utils/error.util";
import { Context } from "src/config/AuthContext.js";
import ServicoForm from "src/forms/ServicoForm";
import dayjs from "dayjs";
import { MiscellaneousServices } from "@mui/icons-material";
import { atualizarServico, obterServicos, obterServicosPorTextoDeBusca } from "../../services/servicos.service.ts";

const Servicos = () => {

  const navigate = useNavigate();

  const { handleLogout } = useContext(Context);

  const [loading, setLoading] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [msg, setMsg] = useState("");

  const [servicosData, setServicosData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);

  const columns = [
    { id: "idServico", label: "ID", field: "idServico" },
    { id: "descricao", label: "Nome do Serviço", field: "descricao" },
  ];

  const handleOpenModal = async (rowData) => {
    (rowData.idServico !== undefined)
      ? setEditRowData(rowData)
      : setEditRowData({});

    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSaveChanges = async (data) => {
    setLoading(true);

    await atualizarServico(editRowData.idServico, {servico: data.servico})
      .then(async (response) => {
        setMsg(response.mensagem);
        await getServicos();
        handleCloseModal();
        handleOpenSnackbarSucesso();
      })
      .catch((err) => handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout));

    setLoading(false);
  };

  const getServicos = async () => {
    try {
      const response = await obterServicos();
      var servicos = response.servicos;
      setServicosData(servicos);
    } catch (err) {
      handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await getServicos();
      setLoading(false);
    };

    fetchData();
  }, [navigate]);

  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (!reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleDebouncerChange = async (event) => {
    setLoading(true);
    try {
      const response = await obterServicosPorTextoDeBusca(event.target.value);
      setServicosData(response.servicos);
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setServicosData([]);
      } 
      else {
        handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
      };
    }
    setLoading(false);
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={
          <MiscellaneousServices fontSize="30px"/>
        }
        headerTitle={"Serviços"}
        handleDebounceChange={handleDebouncerChange}
        handleOpenModal={handleOpenModal}
        disableModalButton={true}
      />

      <TabelaDinamica
        data={servicosData}
        columns={columns}
        loading={loading}
        orderColumn={'idUsuario'}
        onEditButtonClick={handleOpenModal}
        disableDelete={true}
      />

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            width: "140%", // Defina a largura desejada
            height: "100vh",
          },
        }}
        maxWidth="lg" // Defina o tamanho máximo do modal
      >
        <DialogTitle className={styles.popupHeader}>
          <div className={styles.linhaTituloPopup} />
          <div className={styles.tituloPopupContainer}>
            <PersonIcon className={styles.iconeTituloPopup} />
            <h1 className={styles.tituloPopup}>
              {editRowData.idServico
                ? "Edição de Serviço"
                : "Cadastro de Serviço"}
            </h1>
          </div>
        </DialogTitle>
        <ServicoForm
          servicoValues={Object.assign({}, editRowData)}
          onSubmit={handleSaveChanges}
          onClose={handleCloseModal}
          className={styles.popupContent}
        >
        </ServicoForm>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default Servicos;
